export default "__VITE_PUBLIC_ASSET__eafa2fa1__"